var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "connector-consistency" },
    [
      _c(
        "div",
        {
          staticClass: "d-flex align-items-center justify-content-between mb-3",
        },
        [
          _c(
            "b-form-checkbox",
            {
              attrs: { size: "md", disabled: _vm.loading, switch: "" },
              model: {
                value: _vm.onlyEnabled,
                callback: function ($$v) {
                  _vm.onlyEnabled = $$v
                },
                expression: "onlyEnabled",
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("connector.label.only_enabled")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: { variant: "info", disabled: _vm.loading },
              on: { click: _vm.getAllDatas },
            },
            [
              _vm.loading
                ? _c("b-spinner", { staticClass: "mr-2", attrs: { small: "" } })
                : _vm._e(),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("connector.btn.recheck_consistency")) +
                  "\n    "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-table", {
        staticClass: "mb-0",
        attrs: {
          fields: _vm.fields,
          items: _vm.items,
          small: "",
          responsive: "sm",
          "tbody-tr-class": !_vm.loading ? "connector-consistency-row" : null,
          busy: _vm.loading,
        },
        on: {
          "row-clicked": function ($event) {
            return _vm.onRowClick($event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "table-busy",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "text-center text-info my-3" },
                  [
                    _c("b-spinner", {
                      staticClass: "align-middle mr-2",
                      attrs: { small: "" },
                    }),
                    _vm._v(" "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.$t("connector.label.loading_consistency"))
                      ),
                    ]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "cell(anisen)",
            fn: function (row) {
              return [
                _vm._v("\n      " + _vm._s(row.value) + "\n      "),
                !_vm.onlyEnabled && row.item.anisenEnabled
                  ? [
                      _c("i", {
                        staticClass: "fa-solid fa-circle-info",
                        attrs: {
                          id:
                            "connector-consistency-anisen-tooltip-" + row.index,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            target:
                              "connector-consistency-anisen-tooltip-" +
                              row.index,
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("connector.label.nb_with_enabled", [
                                  row.item.anisenEnabled,
                                ])
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(connector)",
            fn: function (row) {
              return [
                _vm._v("\n      " + _vm._s(row.value) + "\n      "),
                !_vm.onlyEnabled && row.item.connectorEnabled
                  ? [
                      _c("i", {
                        staticClass: "fa-solid fa-circle-info",
                        attrs: {
                          id:
                            "connector-consistency-connector-tooltip-" +
                            row.index,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            target:
                              "connector-consistency-connector-tooltip-" +
                              row.index,
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("connector.label.nb_with_enabled", [
                                  row.item.connectorEnabled,
                                ])
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(status)",
            fn: function (row) {
              return [
                _c("span", {
                  staticClass: "status-dot",
                  class: `status-dot-${_vm.getStatusColor(row.item.ratio)}`,
                  attrs: { title: _vm.getStatusTitle(row.item.ratio) },
                }),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("modal-consistency-details", { ref: "modalDetails" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }